import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/data-mapping`;

export const dataMappingService = {
  detectSchema: async (fileId) => {
    const response = await axios.post(`${API_BASE}/detect-schema`, { file_id: fileId });
    return response.data;
  },

  suggestMappings: async (fileId, targetEntity, sourceSystemType) => {
    const response = await axios.post(`${API_BASE}/suggest-mappings`, {
      file_id: fileId,
      target_entity: targetEntity,
      source_system_type: sourceSystemType
    });
    return response.data;
  },

  suggestMultiEntity: async (fileId, sourceSystemType) => {
    const response = await axios.post(`${API_BASE}/suggest-multi-entity`, {
      file_id: fileId,
      source_system_type: sourceSystemType
    });
    return response.data;
  },

  confirmMappings: async (fileId, data) => {
    const response = await axios.put(`${API_BASE}/mappings/${fileId}/confirm`, data);
    return response.data;
  },

  applyMapping: async (templateId, fileId) => {
    const response = await axios.post(`${API_BASE}/mappings/${templateId}/apply`, { file_id: fileId });
    return response.data;
  },

  assessRules: async (fieldMappings) => {
    const response = await axios.post(`${API_BASE}/assess-rules`, { field_mappings: fieldMappings });
    return response.data;
  },

  getTargetEntities: async () => {
    const response = await axios.get(`${API_BASE}/target-entities`);
    return response.data;
  },

  listTemplates: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source_system_type) params.append('source_system_type', filters.source_system_type);
    if (filters.target_ofp_entity) params.append('target_ofp_entity', filters.target_ofp_entity);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/templates?${params}`);
    return response.data;
  },

  createTemplate: async (data) => {
    const response = await axios.post(`${API_BASE}/templates`, data);
    return response.data;
  },

  getTemplate: async (id) => {
    const response = await axios.get(`${API_BASE}/templates/${id}`);
    return response.data;
  },

  recordFeedback: async (data) => {
    const response = await axios.post(`${API_BASE}/feedback`, data);
    return response.data;
  },

  listFeedback: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/feedback?${params}`);
    return response.data;
  }
};

export default dataMappingService;
